import i18next from 'i18next';
import { ENDPOINT_MESSAGE_RECEIVED, KICKED_OUT } from '../base/conference/actionTypes';
import { MALKA_END_MEETING_MESSAGE } from '../base/conference/constants';
import { hangup } from '../base/connection/actions.web';
import { getParticipantDisplayName } from '../base/participants/functions';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { isGroupPlatformCall } from '../base/user-role/functions';
import { openAllowToggleCameraDialog, setCameraFacingMode } from '../base/tracks/actions.web';
import { CAMERA_FACING_MODE_MESSAGE } from '../base/tracks/constants';
import './joinMiddleware.web';
import './middleware.any';
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case ENDPOINT_MESSAGE_RECEIVED: {
            const { participant, data } = action;
            if (data?.name === CAMERA_FACING_MODE_MESSAGE) {
                APP.store.dispatch(openAllowToggleCameraDialog(
                /* onAllow */ () => APP.store.dispatch(setCameraFacingMode(data.facingMode)), 
                /* initiatorId */ participant.getId()));
            }
            // In a group call one person's hang-up never ends it for the others:
            // an older app still sends this when it leaves (leaveConference).
            if (data?.name === MALKA_END_MEETING_MESSAGE
                && !isGroupPlatformCall(store.getState()['features/base/conference'].room)) {
                store.dispatch(hangup(true, 'The meeting was ended by another participant.'));
            }
            break;
        }
        case KICKED_OUT: {
            const { dispatch } = store;
            const { participant } = action;
            const participantDisplayName = getParticipantDisplayName(store.getState, participant.getId());
            dispatch(hangup(true, i18next.t('dialog.kickTitle', { participantDisplayName })));
            break;
        }
    }
    return next(action);
});
